/** Aligned with Flows::DefinitionValidator (Ruby) */

export const FLOW_DEFINITION_VERSION = 2;

/** Node types the user can add from the builder (not start/end) */
export const FLOW_BUILDER_ADDABLE_TYPES = [
  'message',
  'wait_input',
  'branch',
  'add_label',
  'assign_team',
  'whatsapp_template',
];

/** All types including structural */
export const FLOW_NODE_TYPE_KEYS = [
  'start',
  'message',
  'wait_input',
  'branch',
  'add_label',
  'assign_team',
  'whatsapp_template',
  'end',
];

export const FLOW_MATCH_TYPES = ['equals', 'contains'];

export const FLOW_NODE_META = {
  start: { icon: 'i-lucide-play', i18n: 'FLOWS.NODE_TYPE_START' },
  message: {
    icon: 'i-lucide-message-square-text',
    i18n: 'FLOWS.NODE_TYPE_MESSAGE',
  },
  wait_input: {
    icon: 'i-lucide-git-branch',
    i18n: 'FLOWS.NODE_TYPE_WAIT_INPUT',
  },
  branch: { icon: 'i-lucide-split', i18n: 'FLOWS.NODE_TYPE_BRANCH' },
  add_label: { icon: 'i-lucide-tag', i18n: 'FLOWS.NODE_TYPE_ADD_LABEL' },
  assign_team: { icon: 'i-lucide-users', i18n: 'FLOWS.NODE_TYPE_ASSIGN_TEAM' },
  whatsapp_template: {
    icon: 'i-lucide-message-circle',
    i18n: 'FLOWS.NODE_TYPE_WHATSAPP_TEMPLATE',
  },
  end: { icon: 'i-lucide-flag', i18n: 'FLOWS.NODE_TYPE_END' },
};
